import { apiFetch } from './client'

export type HelpSectionId = 'start' | 'projects' | 'sprints' | 'context'

export interface HelpSectionDto {
  section: HelpSectionId
  markdown: string
}

export function fetchHelpSection(section: HelpSectionId): Promise<HelpSectionDto> {
  return apiFetch<HelpSectionDto>(`/api/help/${encodeURIComponent(section)}`)
}
